import React from 'react'
import { Button } from '@material-ui/core'

import useStyles from './styles'

const SSOButton = ({ SSOLogin, setSSOLogin }) => {
  const classes = useStyles()

  const handleSSOLogin = () => {
    setSSOLogin(!SSOLogin)
  }

  return (
    <>
      {SSOLogin ? (
        <Button className={classes.ssoButonLogin} onClick={handleSSOLogin}>
          Entrar sem SSO
        </Button>
      ) : (
        <Button className={classes.ssoButonLogin} onClick={handleSSOLogin}>
          SSO
        </Button>
      )}
    </>
  )
}

export default SSOButton
